import FullCalendar from '@fullcalendar/react';
import { DateSelectArg, EventClickArg } from '@fullcalendar/core';
import { useRef, useState, useCallback } from 'react';

import { fTimestamp } from 'src/utils/format-time';
import { ICalendarRange } from 'src/type/calendar';
import dayjs from 'dayjs';
import { sleep } from 'src/utils/sleep';

// ----------------------------------------------------------------------

export default function useCalendar() {
  const calendarRef = useRef<FullCalendar>(null);

  const calendarEl = calendarRef.current;

  const [date, setDate] = useState(new Date());

  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
  const [selectedRange, setSelectedRange] = useState<ICalendarRange>(null);

  const onOpenForm = useCallback(() => {
    setOpenForm(true);
  }, []);

  const onOpenView = useCallback(() => {
    setOpenView(true);
  }, []);

  const onCloseView = useCallback(async () => {
    setOpenView(false);
  }, []);

  const onCloseForm = useCallback(async () => {
    setOpenForm(false);
    await sleep(200);
    setSelectedRange(null);
    setSelectedDate(null);
    setSelectedEventId(null);
  }, []);

  const onDateToday = useCallback(() => {
    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.today();
      setDate(calendarApi.getDate());
    }
  }, [calendarEl]);

  const onDatePrev = useCallback(() => {
    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.prev();
      setDate(calendarApi.getDate());
    }
  }, [calendarEl]);

  const onDateNext = useCallback(() => {
    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.next();
      setDate(calendarApi.getDate());
    }
  }, [calendarEl]);

  const onSelectRange = useCallback(
    (arg: DateSelectArg) => {
      if (calendarEl) {
        const calendarApi = calendarEl.getApi();

        calendarApi.unselect();
      }

      if (dayjs(arg.end).diff(dayjs(arg.start), 'day') > 1) {
        setSelectedRange({
          start: fTimestamp(arg.start),
          end: fTimestamp(arg.end),
        });
      } else {
        setSelectedDate(arg.start);
      }

      onOpenForm();
    },
    [calendarEl, onOpenForm]
  );

  const onClickEvent = useCallback(
    (arg: EventClickArg) => {
      const { event } = arg;

      const clickedDate = event.start;

      setSelectedEventId(event.id);
      setSelectedDate(clickedDate);
      setOpenView(true);

      // if (clickedDate) {
      // const allow = isTodayOrAfter(clickedDate);

      // if (allow) {
      // setSelectedDate(clickedDate);
      // onOpenForm();
      // }
      // }
    },
    [onOpenForm]
  );

  return {
    calendarRef,
    //

    date,
    //
    onDatePrev,
    onDateNext,
    onDateToday,

    //
    openForm,
    openView,
    onOpenForm,
    onOpenView,
    onCloseForm,
    onCloseView,
    //
    selectedDate,
    selectedRange,
    selectedEventId,
    //
    onSelectRange,
    onClickEvent,
  };
}
